module.exports = __webpack_public_path__ + "img/slide_002_g4.7624cb31.jpg";